import { useEffect, useRef } from "react";
import { Client } from "@stomp/stompjs";
import { useNotificationsStore, type AdminNotificationEvent } from "@/store/notificationsStore";

export function useAdminNotificationsSocket(adminBotId: number | null, enabled: boolean) {
    const pushEvent = useNotificationsStore((s) => s.pushEvent);
    const clientRef = useRef<Client | null>(null);

    useEffect(() => {
        if (!enabled) return;
        if (!adminBotId) return;

        const proto = window.location.protocol === "https:" ? "wss" : "ws";
        const host = window.location.host;

        // ВАЖНО: endpoint ровно /ws (как в registerStompEndpoints)
        const brokerURL = `${proto}://${host}/ws`;

        const destination = `/topic/admin/${adminBotId}/notifications`;

        const client = new Client({
            brokerURL,
            reconnectDelay: 3000, // можно убрать если не надо
            onConnect: () => {
                client.subscribe(destination, (message) => {
                    try {
                        const data = JSON.parse(message.body) as AdminNotificationEvent;
                        pushEvent(data);
                    } catch (e) {
                        console.error("[stomp] bad message", e);
                    }
                });
            },
            onStompError: (frame) => {
                console.error("[stomp] error", frame.headers["message"], frame.body);
            },
        });

        client.activate();
        clientRef.current = client;

        return () => {
            try {
                client.deactivate();
            } catch {}
            clientRef.current = null;
        };
    }, [adminBotId, enabled, pushEvent]);
}
